'use client';

import Image from '@src/components/atoms/safe-image';
import { usePathname, useParams } from 'next/navigation';

// Assets
import Century21 from '@public/png/century-21-black-1.png';
import ArrowUpRight from '@public/png/arrow-up-right-1.png';
import useRedirect from '@src/hooks/useRedirectExtend';

import useGlobalCtx from '@src/context/global-ctx';

const Footer = () => {
  const { companyDetails } = useGlobalCtx();

  const { companySlug } = useParams()
  const pathname = usePathname()
  const isHomepage = pathname === "/";

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  const redirect = useRedirect();
  const handleToHomepage = () => {
    redirect("/")
  }

  return (
    <div className={`main-wrapper pt-[40px] ${isHomepage ? "bg-white-3" : "bg-white-4"}`}>
      <div className='content-wrapper mb-4 
      dd-lg:mb-0'>
        <div className='flex justify-between items-start mb-6 
        dd-xl:flex-col-reverse dd-xl:items-center dd-xl:justify-center 
        dd-lg:items-start dd-lg:mb-[56px]'>
          <div className='dd-xl:flex dd-xl:flex-col dd-xl:items-center 
          dd-xl:mb-[104px] 
          dd-lg:mb-0'>
            <p className='w-[568px] text-17 text-black-1 mb-[32px] 
            dd-xl:text-center 
            dd-lg:text-start dd-lg:w-full'>Dapatkan keuntungan dari kemitraan kami yang kokoh dan andal. Kami bangga bermitra dengan perusahaan terkemuka untuk memberikan layanan terbaik
              kepada Anda.</p>
          </div>
          <div className='flex flex-col items-center 
          dd-xl:mb-10 
          dd-lg:block'>
            <Image
              width="auto"
              height="auto"
              src={Century21}
              className='w-[214.26px] h-6 object-contain mb-2 cursor-pointer'
              onClick={handleToHomepage}
              alt='CENTURY 21'
            />
            <p className='text-[16px] text-black-3 font-typold-extended-medium leading-[89%] tracking-[0.16px]'>{companyDetails?.name ?? ""}</p>
          </div>
        </div>

        <div className='flex justify-between items-end 
        dd-lg:flex-col-reverse dd-lg:items-start'>
          <div className='flex items-end'>
            <p className='mr-2 text-13 text-black-1'>KEMBALI KE ATAS</p>
            <button onClick={handleScrollToTop} className='cursor-pointer p-0.5 border border-solid border-black-1 w-[20px] h-[20px] flex items-center justify-center rounded-[80px]'>
              <Image
                src={ArrowUpRight}
                alt='Arrow Up Right'
                width={16}
                height={16}
                className='object-fit'
              />
            </button>
          </div>
        </div>
      </div>

      <div className='w-full h-[1px] border border-solid border-grey-0 my-6' />

      <div className='content-wrapper mb-6'>
        <div className='flex items-center justify-between 
        dd-lg:block'>
          <p className='text-13 text-black-1 
          dd-lg:mb-2'>Designed by CENTURY 21 Indonesia</p>
          <p className='text-13 text-black-1'>{"©"} 2024 CENTURY 21 Indonesia. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  )
}

export default Footer